import { Result } from "antd";
import "./summary.less";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@awesome.me/kit-b311a11e92/icons/classic/solid";
import { useTranslation } from "react-i18next";

function Summary() {
  const { t } = useTranslation();
  
  return (
    <Result
      className="summary"
      title={t("SYSTEM_CHECK_SUMMARY_TITLE")}
      subTitle={t("SYSTEM_CHECK_SUMMARY_SUBTITLE")}
      icon={<FontAwesomeIcon fontSize={128} icon={faCircleCheck} />}
    />
  );
}

export default Summary;
